import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import SearchProgress from '@Services/SearchProgress';
import LoaderProgress from './LoaderProgress';

import './Loader.custom.scss';
import './Loader.theme.scss';

export default class Loader extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      progress: props.startProgress,
    };
  }

  componentDidMount() {
    const { progressValue, calculatePercentage, startProgress, interval } = this.props;
    if (progressValue || progressValue === 0) {
      return;
    }
    const { progress } = this.state;

    let runningTime = 0;

    this.interval = setInterval(() => {
      if (progress >= 100) {
        this.setState({
          progress: 99,
        });

        clearInterval(this.interval);

        return;
      }

      // eslint-disable-next-line no-plusplus
      runningTime++;

      const nextProgress = calculatePercentage(runningTime) + startProgress;

      this.setState({
        progress: nextProgress,
      });
    }, interval);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  render() {
    const { showText, className, loaderProgressProps, progressValue } = this.props;
    const { progress } = this.state;
    return (
      <div className={classnames(className, 'new-loader')}>
        <LoaderProgress {...loaderProgressProps} percentages={!!progressValue || progressValue === 0 ? progressValue : progress} />
        {showText && <span className="new-loader--text">{progressValue || progress}%</span>}
      </div>
    );
  }
}

Loader.defaultProps = {
  showText: true,
  startProgress: 0,
  interval: 800,
  calculatePercentage: SearchProgress.calculatePercentage,
};

Loader.propTypes = {
  showText: PropTypes.bool,
  startProgress: PropTypes.number,
  interval: PropTypes.number,
  calculatePercentage: PropTypes.func,
  loaderProgressProps: PropTypes.object,
  progressValue: PropTypes.number,
  className: PropTypes.string,
};
